import { Tag } from 'antd';
import { createElement } from 'react';

export const badgeColors: Record<string, string> = {
  err: 'error',
  ok: 'success',
  info: 'processing',
  warn: 'warning',
  default: 'default',
};

/** Вариант бейджа модуля в UI (бэкенд не присылает badge_variant). */
const REPORT_BADGE_BY_ID: Record<number, string> = {
  1: 'err',
  2: 'ok',
  3: 'info',
  4: 'ok',
  5: 'info',
  6: 'ok',
  7: 'warn',
  8: 'info',
  9: 'default',
};

export function reportTagBadgeVariant(reportId: number): string {
  return REPORT_BADGE_BY_ID[reportId] ?? 'default';
}

export const SCHEDULE_OPTIONS = [
  { value: '', label: 'Не задано' },
  { value: 'daily', label: 'Ежедневно' },
  { value: 'weekly', label: 'Еженедельно (пн)' },
  { value: 'monthly', label: 'Ежемесячно (1 число)' },
  { value: 'quarterly', label: 'Ежеквартально' },
];

export function channelTag(c: string) {
  if (c === 'Внутренние') return createElement(Tag, { color: 'gold' }, c);
  return createElement(Tag, { color: 'processing' }, c);
}
